import React from "react";
import { Card, Button } from "react-bootstrap";
import Chart from "react-apexcharts";

const EmployeeDistribution = () => {

  const series = [
    {
      name: "Company",
      data: [40, 20, 35, 10]
    }
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },

    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "93%",   // ✅ wider bars
        distributed: true
      }
    },

    colors: ["#ee8742", "#ee894f", "#f2b08b", "#f2b08b"],

    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.2,
        gradientToColors: ["#f19a68", "#ec9b6d", "#ee9b6b", "#f19f6f"],
        opacityFrom: 1,
        opacityTo: 0.4,
        stops: [0, 100]
      }
    },

    dataLabels: {
      enabled: true,
      formatter: val => val + "%",
      offsetY: -6,
      style: {
        fontSize: "14px",
        fontWeight: "600",
        colors: ["#000"]
      }
    },

    xaxis: {
      categories: ["Sales", "Front End", "React", "UI"],
      labels: {
        style: {
          fontSize: "14px",
          fontWeight: 500
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },

    yaxis: {
      show: false
    },

    grid: {
      show: false,
      padding: {
        left: 10,
        right: 10
      }
    },

    tooltip: {
      theme: "light",
      y: {
        formatter: val => "Company: " + val
      }
    }
  };

  return (
    <div className="mt-3 d-flex w-100">
      <Card className="flex-fill employee-card w-100">

        <Card.Body className="pb-0">

          {/* Header */}
          <div className="header-box">
            <h2 className="card-title mb-0">
              Top Employee Distribution
            </h2>

            <Button variant="light" size="sm">
              View All
            </Button>
          </div>

          {/* Chart */}
          <div className="chart-area">
            <Chart
              options={options}
              series={series}
              type="bar"
              height={380}
            />
          </div>

        </Card.Body>

        <style>{`

.employee-card{
border-radius:10px;
}

/* header */

.header-box{
display:flex;
align-items:center;
justify-content:space-between;
border:1px solid #e9ecef;
border-left:3px solid #ff7a21;
padding:10px 15px;
border-radius:6px;
margin-bottom:10px;
}

.header-box h2{
font-size:18px;
font-weight:600;
}

/* chart */

.chart-area{
padding-top:10px;
}

/* tooltip */

.apexcharts-tooltip{
border-radius:8px !important;
box-shadow:0 3px 10px rgba(0,0,0,0.15);
}

.apexcharts-tooltip-title{
font-weight:600;
}

        `}</style>

      </Card>
    </div>
  );
};

export default EmployeeDistribution;